import {
  join,
  filter,
  pathOr,
  map,
  toUpper,
  gt,
  includes,
  toLower,
  isEmpty,
  not,
  set,
  lensPath
} from 'ramda';
import { compose } from 'recompose';

const ADDRESS_FIELDS = [
  ["street"],
  ["city"],
  ["state"],
  ["zipcode"], // is this needed  ?
  ["zip_code"] // This name isn't correct.
];

const PROPERTY_ADDRESS_FIELDS = [
  ["street"],
  ["city"],
  ["state"],
  ["zip_code"],
  ["country"]
];

const CITY_STATE = [
  ["city"],
  ["state"]
];

const SEPARATOR_ENDS_WITH_BLANK = ", ";

export const joinWith = (items: string[], separator: any) => {
  return join(separator, filter(x => gt(x.length, 0), items));
};

export const addressStringified = (data: any) => {
  return joinWith(
    map(x => pathOr("", x, data), ADDRESS_FIELDS),
    SEPARATOR_ENDS_WITH_BLANK
  );
};

export const addressShortener = (data: any) => {
  return joinWith(
    map(x => toUpper(pathOr("", x, data)), CITY_STATE),
    SEPARATOR_ENDS_WITH_BLANK
  );
};

export const isCountryUS = (country: string) => {
  const c = toLower(`${country}`)
  return isEmpty(c) || includes(c, ['us', 'usa', 'united states'])
}

export const isCountryNotUS = (country: string) => {
  return not(isCountryUS(country))
}

export const mergePropertyAddress = (address: any, unit: string,county?:string) => {
  return compose(
    set(lensPath(['address', 'street']), pathOr('', ['street'], address)),
    set(lensPath(['address', 'state']), pathOr('', ['state'], address)),
    set(lensPath(['address', 'zip_code']), pathOr('', ['zip_code'], address)),
    set(lensPath(['address', 'country']), pathOr('', ['country'], address)),
    set(lensPath(['address', 'city']), pathOr('', ['city'], address)),
    set(lensPath(['address', 'unit_number']), unit),
    set(lensPath(['address', 'county']), county),
    //default values for export 3.4 mandetory fields
    set(lensPath(["details", 'financed_unit_count']), "1"),
    set(lensPath(["purpose", 'construction', 'present_value_of_lot']), "12000")
  );
}

export const addressStringify = (data: any) => {
  return joinWith(
    map(x => pathOr("", x, data), PROPERTY_ADDRESS_FIELDS),
    SEPARATOR_ENDS_WITH_BLANK
  );
};
